import "@fontsource/raleway"; // Defaults to weight 400
import "@fontsource/raleway/500.css";
import "@fontsource/raleway/600.css";
import "@fontsource/raleway/700.css";

import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  breakpoints: {
    sm: "481px",
    md: "769px",
    lg: "993px",
    xl: "1281px",
    xxl: "1440px",
    "2xl": "1537px",
  },
  styles: {
    global: {
      h1: {
        fontSize: "56px",
        // color: '#1A212D',
      },
      p: {
        // color: "#4A5568",
        fontWeight: "500",
      },
    },
  },
  fonts: { heading: "Raleway !important", body: "Raleway !important" },

  colors: {
    purpleHeart: {
      "50": "#faf7fc",
      "100": "#f4eff8",
      "200": "#e7def0",
      "300": "#d6c4e3",
      "400": "#bfa1d1",
      "500": "#a27bba",
      "600": "#865c9d",
      "700": "#6e4a81",
      "800": "#654475",
      "900": "#2e1b37",
    },
    rawSienna: {
      "50": "#FFEAE6",
      "100": "#F6C5BE",
      "200": "#EA9E96",
      "300": "#E0746C",
      "400": "#D54843",
      "500": "#BC2A2A",
      "600": "#93261F",
      "700": "#691F15",
      "800": "#42150A",
      "900": "#1D0801",
    },
    gunPowder: {
      "50": "#f7f7f8",
      "100": "#eeedf1",
      "200": "#d8d8df",
      "300": "#b5b5c4",
      "400": "#8d8da3",
      "500": "#6f6e89",
      "600": "#5a5970",
      "700": "#4e4d61",
      "800": "#373743",
      "900": "#26252c",
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "normal",
      },
      variants: {
        unstyledPagination: {
          color: "#5A5970",
          fontSize: "16px",
          fontWeight: "700",
        },
        solidPagination: {
          w: "48px",
          h: "44px",
          bg: "rgba(225, 128, 66, 0.20)",
          color: "#26252C",
          fontSize: "16px",
          fontWeight: "600",
          borderRadius: "full",
        },
        solid: {
          bg: "#BC2A2A",
          h: "48px",
          color: "white",
          fontSize: "18px",
          fontWeight: "600",
          borderRadius: "full",
          size: "lg",
          _hover: {
            bg: "#D54843",
          },
        },
        solidWhite: {
          bg: "white",
          h: "48px",
          color: "#BC2A2A",
          fontSize: "18px",
          fontWeight: "600",
          borderRadius: "full",
          size: "lg",
          _hover: {
            bg: "rawSienna.700",
            color: "white",
          },
        },
        outline: {
          h: "48px",
          bg: "transparent",
          color: "#BC2A2A",
          fontSize: "18px",
          fontWeight: "600",
          borderColor: "#BC2A2A",
          borderRadius: "full",
          _hover: {
            bg: "rawSienna.500",
            color: "white",
          },
        },
        outlineWhite: {
          bg: "transparent",
          color: "white",
          border: "1px solid white",
          borderRadius: "full",
          h: "48px",
          fontSize: "18px",
          fontWeight: "600",
          _hover: {
            bg: "white",
            color: "rawSienna.500",
          },
        },
      },
    },

    Link: {
      baseStyle: {
        fontWeight: "500",
        _hover: {
          color: "rawSienna.500",
          textDecor: "none",
        },
      },
    },

    FormLabel: {
      baseStyle: {
        fontSize: "14px",
        lineHeight: "21px",
        color: "#4A5568",
      },
    },
  },
});

export default theme;
